// crypto.randomUUID() is only available in secure contexts (HTTPS or
// localhost). When the app is served over plain HTTP from a LAN IP — e.g.
// http://192.168.x.x:5173 from a phone in dev — the method is undefined and
// any code calling it throws TypeError, silently aborting handlers.
//
// crypto.getRandomValues() works in any context, so we synthesize a v4
// UUID from it. The Math.random() fallback is a last resort for ancient
// runtimes; IDs there are NOT cryptographically secure but won't throw.

export function randomId(): string {
  const c: Crypto | undefined = typeof crypto !== 'undefined' ? crypto : undefined;

  if (c?.randomUUID) {
    try { return c.randomUUID(); } catch { /* fall through */ }
  }

  if (c?.getRandomValues) {
    const bytes = new Uint8Array(16);
    c.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
    return (
      hex.slice(0, 4).join('') + '-' +
      hex.slice(4, 6).join('') + '-' +
      hex.slice(6, 8).join('') + '-' +
      hex.slice(8, 10).join('') + '-' +
      hex.slice(10, 16).join('')
    );
  }

  return `${Date.now().toString(16)}-${Math.random().toString(36).slice(2, 11)}`;
}
